import { API_BASE_URLS } from '../config/api.config';

const BASE_PATH = '/FileManagement';

const buildFilesUrl = (path = '') => {
  // Use API_BASE_URLS.backend directly to avoid double /api/v1
  const baseUrl = (API_BASE_URLS.backend || '').replace(/\/$/, '');
  return `${baseUrl}${BASE_PATH}${path}`;
};

export const FILES_ENDPOINTS = {
  UPLOAD_BATCH: buildFilesUrl('/files'),
  DELETE: (fileId) => buildFilesUrl(`/${fileId}`),
  GET_ALL: (orderId) => buildFilesUrl(`/review/${orderId}`),
  REPLACE: buildFilesUrl(`/files/replace`),
  DELETEONE: (fileUploadId, deletedBy) => buildFilesUrl(`/files/${fileUploadId}?deletedBy=${encodeURIComponent(deletedBy)}`),
  DELETEALL: (orderId) => buildFilesUrl(`/files/order/${orderId}`),
  ACTIVITY_LOG: buildFilesUrl(`/confirm-mapping-clicked`),
  GET_SAS_TOKEN: buildFilesUrl('/files/upload-sas'), // Endpoint to get fresh SAS token
  GET_PREVIEW: (orderId, fileId) =>
    buildFilesUrl(`/orders/${orderId}/files/${fileId}/save-and-continue`),
  SAVE_PREVIEW: (orderId, fileId) =>
    buildFilesUrl(`/orders/${orderId}/files/${fileId}/save-and-continue`),
  GET_PYCY_FLAG: (orderID) => buildFilesUrl(`/orders/${orderID}/processing-configuration/consider-py-ending-balance`),
  POST_PYCY_FLAG: (orderID) => buildFilesUrl(`/orders/${orderID}/processing-configuration/consider-py-ending-balance`),
};

export const AZURE_STORAGE_ENDPOINTS = {
  get BASE_URL() {
    const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME;
    return accountName ? `https://${accountName}.blob.core.windows.net` : '';
  },

  CONTAINER: (containerName) => {
    const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME;
    return `https://${accountName}.blob.core.windows.net/${containerName}`;
  },

  BLOB: (containerName, blobName) => {
    const accountName = process.env.REACT_APP_AZURE_STORAGE_ACCOUNT_NAME;
    return `https://${accountName}.blob.core.windows.net/${containerName}/${blobName}`;
  },
};

export default {
  FILES_ENDPOINTS,
  AZURE_STORAGE_ENDPOINTS,
};
